import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Save } from 'lucide-react';

export const CategoryFormDialog = ({ open, onOpenChange, formData, setFormData, onSubmit, isEdit = false }) => {
  const prefix = isEdit ? 'edit-' : '';
  
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{isEdit ? 'Modifier la catégorie' : 'Ajouter une catégorie'}</DialogTitle>
          <DialogDescription>{isEdit ? 'Modifiez les informations de cette catégorie' : 'Créez une nouvelle catégorie de dépense'}</DialogDescription>
        </DialogHeader>
        <form onSubmit={onSubmit} className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor={`${prefix}cat-nom`}>Nom de la catégorie *</Label>
            <Input
              id={`${prefix}cat-nom`}
              value={formData.nom}
              onChange={(e) => setFormData({ ...formData, nom: e.target.value })}
              required
              placeholder="Ex: Ch3ir, Gort, Vétérinaire..."
              data-testid={`${prefix}category-nom-input`}
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor={`${prefix}cat-description`}>Description</Label>
            <Textarea
              id={`${prefix}cat-description`}
              value={formData.description}
              onChange={(e) => setFormData({ ...formData, description: e.target.value })}
              placeholder="Description de la catégorie (optionnel)"
              data-testid={`${prefix}category-description-input`}
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor={`${prefix}cat-couleur`}>Couleur d'affichage</Label>
            <Input
              id={`${prefix}cat-couleur`}
              type="color"
              value={formData.couleur}
              onChange={(e) => setFormData({ ...formData, couleur: e.target.value })}
              data-testid={`${prefix}category-couleur-input`}
            />
          </div>
          
          <div className="flex items-center justify-between p-4 bg-amber-50 dark:bg-amber-900/20 rounded-lg border border-amber-200 dark:border-amber-800">
            <div className="space-y-0.5">
              <Label className="text-base font-medium">Catégorie d'alimentation</Label>
              <p className="text-sm text-gray-500 dark:text-gray-400">Cochez si c'est de la nourriture (sera ajouté au stock)</p>
            </div>
            <button
              type="button"
              onClick={() => setFormData({ ...formData, is_alimentation: !formData.is_alimentation })}
              className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${
                formData.is_alimentation ? 'bg-amber-500' : 'bg-gray-300'
              }`}
              data-testid={`${prefix}category-alimentation-toggle`}
            >
              <span
                className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                  formData.is_alimentation ? 'translate-x-6' : 'translate-x-1'
                }`}
              />
            </button>
          </div>

          {formData.is_alimentation && (
            <div className="space-y-2 p-4 bg-blue-50 dark:bg-blue-900/20 rounded-lg border border-blue-200 dark:border-blue-800">
              <Label htmlFor={`${prefix}cat-seuil`}>Seuil d'alerte stock</Label>
              <Input
                id={`${prefix}cat-seuil`}
                type="number"
                min="0"
                step="0.5"
                value={formData.seuil}
                onChange={(e) => setFormData({ ...formData, seuil: e.target.value })}
                placeholder="Ex: 5 (alerte quand stock < 5)"
                data-testid={`${prefix}category-seuil-input`}
              />
              <p className="text-xs text-gray-500 dark:text-gray-400">Vous serez alerté quand le stock descend en dessous de ce seuil</p>
            </div>
          )}

          <div className="flex gap-3">
            <Button
              type="submit"
              className="flex-1 bg-slate-800 hover:bg-slate-900 dark:bg-slate-700 dark:hover:bg-slate-600"
              data-testid={`${prefix}category-submit-button`}
            >
              {isEdit && <Save className="w-4 h-4 mr-2" />}
              {isEdit ? 'Enregistrer les modifications' : 'Ajouter la catégorie'}
            </Button>
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>
              Annuler
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};
